import { View, Text, StyleSheet, TouchableOpacity, Modal } from 'react-native'
import React, { useEffect, useRef, useState } from 'react'
import Colours from '../../utils/Colours'
import UserProfileIcon from '../../icons/UserProfileIcon'
import { useNavigation } from '@react-navigation/native'
import CommentComponent from '../../commentComponent/CommentComponent'
import TablesToUseScreen from '../tablesToUse/TablesToUseScreen'



const BodyaPullScreen = ({ pullsData }) => {

    const [showTableToUseScreen, setShowTableToUseScreen] = useState(false)
    const [showHost, setShowHost] = useState(false)

    const navigate = useNavigation()

    const [btnActiveColor, setBtnActiveColor] = useState(Colours.PRIMARY)
    const [btnTextColor, setBtnTextColor] = useState('white')
    const [currentBtnColor, setCurrentBtnColor] = useState('#E8E8E8');
    const [currentTxtColor, setCurrentTxtColor] = useState(Colours.DARKGRAY)

    useEffect(() => {
        // console.log('pullsData', pullsData)
    }, [pullsData])

    const handleChangeBtnColornText = async () => {
        if (currentBtnColor == '#E8E8E8' & currentTxtColor == Colours.DARKGRAY) {
            setCurrentBtnColor(btnActiveColor)
            setCurrentTxtColor(btnTextColor)
        } else {
            setCurrentBtnColor('#E8E8E8')
            setCurrentTxtColor(Colours.DARKGRAY)
        }
        setShowTableToUseScreen(true)


        // if (newTableData) {
        //     await axios.patch('/tablePulls/tablePullsdata', { table_id: newTableData.table_id, pulls_id: pullsData._id })
        //         .then((response) => {
        //             console.log('RESPONSE', response.data)
        //             console.log('RESPONSE', response.status)
        //             // Alert.alert('You have succesfully funded your table')
        //             navigate.push('Home')

        //         })
        //         .catch((error) => console.log('ERROR', error))

        // }
        // else {
        //     setShowCreateModal(true)
        // }



    }
    return (
        <View style={styles.pullsBodyContainer}>
            <View style={styles.descriptionContainer} >
                <View>
                    <Text style={{ fontSize: 15, fontFamily: 'Sen-Regular', color: Colours.DARKGRAY, textAlign: 'justify' }}>
                        {pullsData.description}
                    </Text>
                </View>

                {showHost && <View style={styles.hostUserSubContainer}>
                    <UserProfileIcon color={Colours.PRIMARY} />
                    <Text style={{ fontSize: 15, fontFamily: 'Sen-Regular', color: Colours.PRIMARY }}>Host</Text>
                    <Text style={{ fontSize: 15, fontFamily: 'Sen-Regular', color: Colours.PRIMARY }}>By Crixus</Text>
                </View>}

            </View>
            <View style={styles.ppleAndBtnContainer}>
                <View style={styles.ppleJoinedContainer}>
                    <Text style={{ fontSize: 25, fontFamily: 'Sen-Bold', color: Colours.PRIMARY }}>250 </Text>
                    <Text style={{ fontSize: 12, fontFamily: 'Sen-Bold', color: Colours.DARKGRAY }}>People Joined</Text>
                </View>
                {/* onPress={handleJoinTableClick} */}
                <TouchableOpacity style={[styles.buttonGray,
                { backgroundColor: currentBtnColor }]}
                    onPress={handleChangeBtnColornText}>
                    <Text style={{ color: currentTxtColor, fontSize: 17, fontFamily: 'Sen-Bold' }}>Join this Pull</Text>
                </TouchableOpacity>

            </View>
            <View style={styles.commentsStyle}>
                <CommentComponent />
            </View>

            <Modal
                animationType='fade'
                visible={showTableToUseScreen}>
                <TablesToUseScreen
                    hideScreen={() => setShowTableToUseScreen(false)}
                    pullsData={pullsData}
                />
            </Modal>

        </View>
    )
}
const styles = StyleSheet.create({
    pullsBodyContainer: {
        padding: 15,
    },
    descriptionContainer: {
        display: 'flex',
        backgroundColor: 'white',
        // height: 200,
        borderRadius: 10,
        padding: 10,
    },
    commentsStyle: {
        paddingTop: 10
    },
    hostUserSubContainer: {
        display: 'flex',
        flexDirection: "row",
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 5
    },
    ppleAndBtnContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: 10,
        backgroundColor: 'white',
        borderRadius: 10,
        padding: 10,
    },
    ppleJoinedContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 7,
        backgroundColor: Colours.LIGHTGRAY,
        borderRadius: 5,
        width: 150,

    },
    buttonGray: {
        display: 'grid',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 15,
        width: 155,
        height: 60,

        //'#E8E8E8'
    },

    higherTablebodyContainer: {
        marginTop: 10,
        padding: 15,
        // width: 400,
        borderRadius: 10,
        //   height:200,
        backgroundColor: 'white',
        //   backgroundColor: '#E8E8E8',
        shadowColor: '#E8E8E8'
    },
    tableValueContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 130,
    },
    // pullNumberContainer: {
    //     display: 'flex',
    //     flexDirection: 'row',
    //     // justifyContent: 'space-between',
    //     alignItems: 'baseline',
    //     // width:130,
    //     gap: 5,
    // },
    tablesListContainer: {
        paddingBottom: 20,
        gap: 2,
    },
    // pullListContainer: {
    //     paddingBottom: 20,
    //     gap: 2,
    // },
    // pullBy: {
    //     display: 'flex',
    //     flexDirection: 'row',
    //     gap: 10,
    //     alignItems: 'baseline',

    // },
    // datesSubContainer: {
    //     display: 'flex',
    //     flexDirection: 'row',
    //     // justifyContent: 'space-between',
    //     alignItems: 'center',
    //     // alignContent:'center',
    //     gap: 5,
    // }
})

export default BodyaPullScreen